<template>

  <v-list two-line>
    <v-subheader>Aircraft</v-subheader>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Registration
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ value.aircraft }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>

</template>

<script>

export default {
  name: 'FlightInfoAc',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  components: {
  },
  methods: {
  },
  computed: {
  }
}
</script>
